export enum ManualEngineAllocationRequestStatus {
    CREATED = 'created',
    STARTED_PENDING_CONFIRMATION = 'started_pending_confirmation',
    STARTED = 'started',
    COMPLETED_PENDING_CONFIRMATION = 'completed_pending_confirmation',
    COMPLETED = 'completed',
}

export enum AllocationRequestStatuses {
    CREATED = 'CREATED',
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    SETTLED = 'SETTLED',
}
